import React, { useState, useEffect } from "react";

import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../Context/InshData";
import { typeCosts, typeQties } from "../../../../services/safe-grd-services";

import deepRenameKeys from "deep-rename-keys";
import GardUnitsForm from "./GardUnitsForm";
import GardUnitsTable from "./GardUnitsTable";
import { GetItemFromOptions } from "../../../../services/global-services";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.green[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },
}));

export default function GardUnit(props) {
  const { AutoOptions,AutoOptionsB } = props;
  const { t } = useTranslation(["forms", "translation"]);

  const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
  const optionsSafeUser = SafesEmp.filter((obj) => obj.branch == sto.branchi);
  const optionsSafesAdmins = AutoOptionsB.Safes.filter((obj) => obj.branch == sto.branchi);
  const [OptionsSafes, setOptionsSafes] = useState(() => {
    return sto.User_typei == 1 ? [{ id: -1, name:t("all"), branch: -1 }, ...optionsSafesAdmins] : [...optionsSafeUser];
  });
  const defBranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches);

  const typeQties = [
    { id: 0,  name:  t("all")},
    { id: 1,name:t("items_except_negative")},
    { id: 2, name: t("items_except_zero") },
    { id: 3,name: t("items_except_negative_and_zero")},
  ];
  const typeItems = [
    { id: 0, name: t("all") },
    { id: 1, name: t("store") },
    { id: 2, name:t("raw") },
    { id: 3,name:t("industrail")},
  ];
   const defaultGRDparmsEmp = {
    group: { id:-1, name: t("all") },
    safe: optionsSafeUser[0],
    branch:  defBranch,
    typeItem:typeItems[0],
    typeQun:typeQties[3],
    typeCost: typeCosts[3],
  };
 
  const [rptParams, setRptParams] = React.useState(defaultGRDparmsEmp);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [sum, setSum] = useState(false);
  const viewHandle = async () => {
    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/GardUnits?branch=${rptParams.branch?.id}
  &&safe=${rptParams.safe?.id}
  &&group_id=${rptParams.group?.id}
  &&typeQtys=${rptParams.typeQun?.id}
  &&typeItems=${rptParams.typeItem?.id}&&Type_Cost=${rptParams.typeCost?.id}`
      )
      .then((res) => {
       setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        viewHandleOld();
      });
  };
  const viewHandleOld = async () => {
    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/GardUnits?branch=${rptParams.branch?.id}
  &&safe=${rptParams.safe?.id}
  &&group_id=${rptParams.group?.id}
  &&typeQtys=${rptParams.typeQun?.id}
  &&typeItems=${rptParams.typeItem?.id}`
      )
      .then((res) => {
       setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("Fetch error");
        setData([]);
      });
  };

  const his = useHistory();

 
  const printHandle = () => {
    const info = {
      columns: columns,
      // // rout:viewPrms,
      title: t("store_inventory_report_in_unit"),
      data: data?.gardUnits,
     safe:rptParams.safe?.name,
     branch:rptParams.branch?.name,
     group:rptParams.group?.name,
      tot:data?.totals,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: false,
    };
    //console.log(info)
    localStorage.setItem("iInfos", JSON.stringify(info));
    his.push({ pathname: "/ReviewJardUnits" });
    window.location.reload(false);
  };
  let excel_name= "SafeGardUnitsReport" ;
  var columns = [
    { title: t("no"), field: "currency_from" },
    { title: t("barcode"), field: "barcode" },
    { title: t("item"), field: "Name_Item" },
    { title: t("balance"), field: "dec_Qtys" },
    { title: t("average-cost"), field: "Csot" },
    { title: t("total-cost"), field: "Sum_Cost" },
    { title:t("sale-price"), field: "sale_price" },
    { title:t("total-sale-price"), field: "Sum_sale_price" },

  ];

  const excelHeaders = deepRenameKeys(columns, (key) => {
    if (key === "field") return "key";
    if(key === "title") return "label";  
  });

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    if (propName === "branch") {
      const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
      const optinsSafeBranches = SafesEmp.filter((obj) => obj.branch == newValue.id);
      if (optinsSafeBranches !== null) {
        setRptParams({ ...rptParams, [propName]: newValue,safe :optinsSafeBranches[0]});
        setOptionsSafes(sto.User_typei==1? [{ id: -1, name:t("all"), branch: -1 },...optinsSafeBranches]:[...optinsSafeBranches]);
      } else {
        const optinsSafeThis = SafesEmp.filter((obj) => obj.branch == sto.branchi);
        setRptParams({ ...rptParams, [propName]: defBranch,safe:optinsSafeThis[0] });
      }
    }else if(propName==="typeCost") {
      setRptParams({ ...rptParams, [propName]: newValue });
      setData([]);
    } else {
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          { t("store_inventory_report_in_unit")} 
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor:  colors.blue[300] ,
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <GardUnitsForm
            {...{
              AutoOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              typeQties,
              typeItems,
              OptionsSafes,
              typeCosts
            }}
          />    
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  ( inshst.purch.iconBtn,
                  { borderRadius: 0 })
                }
                className={[clasui.button]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
            {data && !fetching && data.gardUnits && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={data?.gardUnits}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={[clasui.button]}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.button, clasSp.clSec]}
                style={
                  ( inshst.purch.iconBtn ,
                  { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  ( inshst.purch.iconBtn,
                  { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
          <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard ,
                  title:t("count_row"),
                  value: data?.totals?.cntTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("total_quantities_defualt"),
                  value: data?.totals?.qtyTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("total_quantites"),
                  value: data?.totals?.vatTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("total_cost"),
                  value: data?.totals?.costTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("sale_total"),
                  value: data?.totals?.totNetTotal.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={colors.green[300]} />
              {!fetching && (
                <GardUnitsTable
                  {...{
                    data: data?.gardUnits ? data?.gardUnits : [],
                    rptParams,
                }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
